export interface lessonPayloed {
    userId: string
}

export interface lessonResponse {
    assignedDate: null
    chapter: string
    completionDate: string
    course: string
    date: null
    detailAssignId: string
    sessionName: string
    status: string
    subject: string
    topic: string
    userId: string
    userName: string
}

export interface LessonUpdate {
    detailAssignId: string
    status: string
    date: string
}

export interface DetailId {
    detailAssignId: string
}

export interface InitialState {
    isLoading: boolean
    getLessonResponse: Array<lessonResponse>
    updateLesson: LessonUpdate
    updateSelectedDetailId: DetailId
}

export const initialState: InitialState = {
    isLoading: false,
    getLessonResponse: [],
    updateLesson: {
        detailAssignId: '',
        status: '',
        date: ''
    },
    updateSelectedDetailId: {
        detailAssignId: ''
    }
}